import React from 'react'

function ContactSection() {
  return (
    <div>
            {/* <!-- Contact Section Start --> */}
        <section class="contact-section fix">
            <div class="container">
                <div class="contact-wrapper">
                    <div class="row">
                        <div class="col-lg-6"></div>
                        <div class="col-lg-6">
                            <div class="contact-content">
                                <div class="section-title">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i> BOOK APPOINTMENT</h5>
                                    <h2 class="wow fadeInUp" data-wow-delay=".3s">Send Us Message</h2>
                                </div>
                                <form action="#">
                                    <div class="row g-4">
                                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".2s">
                                            <div class="form-clt">
                                                <input type="text" name="name" id="name" placeholder="Full Name"/>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                                            <div class="form-clt">
                                                <input type="text" name="email" id="email" placeholder="Email address"/>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                                            <div class="form-clt">
                                                <div class="form">
                                                    <select class="single-select w-100">
                                                        <option>Real Estate</option>
                                                        <option>Property management</option>
                                                        <option>Market analysis</option>
                                                        <option>Home interior</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".6s">
                                            <div class="form-clt">
                                               <textarea name="message" id="message" placeholder="Message Here*"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                                            <button class="theme-btn" type="submit">
                                                Send Message
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="googpemap">
              <iframe src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d28398.36249570839!2d75.71343208517314!3d27.162729695906272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x396daab6b24d6917%3A0xcf2220efaa8a3553!2sCHOMU!3m2!1d27.1655759!2d75.7158062!4m5!1s0x396dabb2f8d64dc7%3A0x570073303cd9bc6e!2sMorija%20chandwaji%20road%20Chomu%2C%205Q52%2BCJC%2C%20Morija%2C%20Rajasthan%20303805!3m2!1d27.1586748!2d75.7523097!5e0!3m2!1sen!2sin!4v1759132955933!5m2!1sen!2sin"  style={{ border: 0 }}  allowfullscreen="" loading="lazy"></iframe>
            </div>
        </section>
    </div>
  )
}

export default ContactSection